var config = require("app/config"),
    get    = require("object-path").get;

/**
 * Helper that inserts slider kind and slide sources into media items. This is a
 * temporary implementation, pending full support for management of slider
 * types, video slider and revolution slider management on the back-end.
 *
 * @param    {Object}  mediaItem  The media item
 * @returns  {Object}  The media item with additional slider data injected
 */
module.exports = function(mediaItem) {
    var revolutionSliderUrl;

    // Empty stubs as needed
    if (!mediaItem.hasOwnProperty("revolution_slider_url")) {
        mediaItem.revolution_slider_url = null;
    }

    if (!mediaItem.hasOwnProperty("preview_url")) {
        mediaItem.preview_url = null;
    }

    if (!mediaItem.hasOwnProperty("header_type")) {
        mediaItem.header_type = null;
    }

    // Attempt to build a RevolutionSlider
    if (!mediaItem.header_type
        && get(config, "revolutionSlider.enabled", false)) {
        revolutionSliderUrl   = get(config, "revolutionSlider.pages." + window.location.pathname, false);

        if (revolutionSliderUrl) {
            mediaItem.header_type           = "revolution_slider";
            mediaItem.revolution_slider_url = revolutionSliderUrl;
        }
    }

    // If that didn't work, attempt to build a VideoSlider
    if (!mediaItem.header_type && mediaItem.preview_url) {
        mediaItem.header_type = "preview_video";
    }

    // If that didn't work, fallback to ImageSlider
    if (!mediaItem.header_type) {
        mediaItem.header_type = "image_slider";
    }

    return mediaItem;
};
